module.exports = __webpack_public_path__ + "static/media/slide4.da2038e8.jpg";